import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import globalConfig from '../../configs/globalConfigs';
import { mapDashboardStatic } from '../../utils/entity-utils';

/* ----------------------------------------------------------------
      SLICE (ACTIONS/REDUCERS)
---------------------------------------------------------------- */

const initialState = {
  texts: {},
  keyNumbers: {},
  loading: false,
  error: null,
  data: {},
};

const dashboardStaticSlice = createSlice({
  name: 'dashboardStatic',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getAllStaticDashboard.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllStaticDashboard.fulfilled, (state, action) => {
      state.loading = false;
      state.texts = action.payload.texts;
      state.keyNumbers = action.payload.keyNumbers;
      state.data = action.payload.data;
    });
    builder.addCase(getAllStaticDashboard.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });
  },
});

export default dashboardStaticSlice.reducer;

/* ----------------------------------------------------------------
      MIDDLEWARE - API CALLS
---------------------------------------------------------------- */
export const getAllStaticDashboard = createAsyncThunk('dashboardStatic/fetchDashboardStatic', async (initialPost) => {
  const { region } = initialPost;
  const result = await axios.post(globalConfig.API_DASHBOARD_STATIC, {
    region,
  });
  const texts = result.data.texts;
  const keyNumbers = result.data.key_numbers;
  const data = mapDashboardStatic(result.data.overview_pathways);

  return { texts, keyNumbers, data };
});
